if (document.querySelector(".custom-notify-available-wrapper")) {

  document.addEventListener('on:variant:change', (event) => {
    const variant = event.detail.variant;
    const is_variant_available = variant.available;
    if(is_variant_available){
      document.querySelector(".custom-notify-main-btn-wrapper").style.display = 'none';
    }else{
      document.querySelector(".custom-notify-main-btn-wrapper").style.display = '';
    }
  });
  
  // const notify_popup = document.getElementById("customNotifyPopupBtn");
  // notify_popup.addEventListener("click", function (e) {
  //   document.querySelector(".custom-notify-popup-wrapper").style.display = "";
  //   document.querySelector(".custom-notify-popup-form .c-notify-email").value = "";
  // });
  // const close_notify_popup = document.getElementById("customNotifyPopupclose");
  // close_notify_popup.addEventListener("click", function (e) {
  //   document.querySelector(".custom-notify-popup-wrapper").style.display = "none";
  // });

  const notify_popup = document.getElementById("customNotifyPopupBtn");
  notify_popup.addEventListener("click", function (e) {
    enableSubmit(false)
    document.querySelector(".custom-notify-popup-form .custom-notify-popup-success-wrap").style.display = "none";
    document.querySelector(".custom-notify-popup-wrapper").style.display = "";
    document.querySelector(".custom-notify-popup-form .c-notify-email").value = "";

    var url = new URL(window.location.href);
    var find_curr_variant = url.searchParams.get("variant");
    if(find_curr_variant){
      document.querySelector(".custom-notify-popup-form .c-notify-option-selection").value = find_curr_variant;
    }
  });
  const close_notify_popup = document.getElementById("customNotifyPopupclose");
  close_notify_popup.addEventListener("click", function (e) {
    document.querySelector(".custom-notify-popup-wrapper").style.display = "none";
  });

  const close_notify_popup_mail = document.querySelector(".custom-notify-popup-form .c-notify-email");
  close_notify_popup_mail.addEventListener("keyup", function (e) {
    const curr_email = this.value;
    if (validateEmail(curr_email) === null || curr_email === "") {
      enableSubmit(false)
    } else {
      enableSubmit(true);
    }
  });

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  function enableSubmit(enable) {
    if(enable){
      document.getElementById("c-notify-form-submit").removeAttribute("disabled");
      document.getElementById("c-notify-form-submit").style.opacity = "";
      document.getElementById("c-notify-form-submit").style.cursor = "pointer";
    }else{
      document.getElementById("c-notify-form-submit").setAttribute("disabled", true);
      document.getElementById("c-notify-form-submit").style.opacity = "0.5";
      document.getElementById("c-notify-form-submit").style.cursor = "not-allowed";
    }
  }
  
  const notify_submit = document.getElementById("c-notify-form-submit");
  notify_submit.addEventListener("click", function (e) {
    e.preventDefault();
    const curr_this_btn = this;
    const curr_email = document.querySelector(".custom-notify-popup-form .c-notify-email").value;
    const curr_product_id = document.querySelector(".custom-notify-popup-form #curr_product_id").value;
    const curr_product_variant = document.querySelector(".custom-notify-popup-form .c-notify-option-selection").value;
    if (curr_email != "") {

      curr_this_btn.setAttribute("disabled", true);
      curr_this_btn.style.opacity = "0.5";
      var klaviyo_data = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: { email: curr_email },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::"+curr_product_variant,
              },
            },
          },
        },
      };

      $.ajax({
        type: "POST",
        url: "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=V7ZBPR",
        beforeSend: function (request) {
          request.setRequestHeader("revision", "2025-01-15");
          request.setRequestHeader("Content-Type", "application/json");
        },
        data: JSON.stringify(klaviyo_data),
        success: function (response) {
          curr_this_btn.style.display = "none";
          document.querySelector(".custom-notify-popup-form .custom-notify-popup-success-wrap").style.display = "";
          curr_this_btn.setAttribute("disabled", false);
          curr_this_btn.style.opacity = "";
        },
        error: function (xhr, status, error) {
          console.log("Error: ", xhr.responseText);
        },
      });
    }
  });
}
